import { render, staticRenderFns } from "./maskSwiper.vue?vue&type=template&id=689474be&scoped=true"
import script from "./maskSwiper.vue?vue&type=script&lang=js"
export * from "./maskSwiper.vue?vue&type=script&lang=js"
import style0 from "./maskSwiper.vue?vue&type=style&index=0&id=689474be&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "689474be",
  null
  
)

export default component.exports